/* =========================================================================
   SVETA ATELIER — shared behaviour + catalogue
   ========================================================================= */
(function(){
  "use strict";

  /* ----------------------------- Catalogue ----------------------------- */
  const isShopify = (window.SHOPIFY_CATALOG && window.SHOPIFY_CATALOG.length) ? true : false;
  const shopifyCatalog = (window.SHOPIFY_CATALOG || []).map(p => Object.assign({
    tone: "stone",
    sizes: (p.variants && p.variants.length > 1) ? p.variants.map(v => v.title) : ["OS"],
    poa: false
  }, p));
  const catalog = shopifyCatalog;
  const byId = id => catalog.find(p => String(p.id) === String(id) || p.handle === id);
  const fmt = n => "\u20B9" + Number(n).toLocaleString("en-IN");
  const priceOf = p => (p && p.product_id) ? (Number(p.price) || 0) / 100 : (Number(p && p.price) || 0);

  /* ------------------------------- Cart -------------------------------- */
  const KEY = "sveta-cart-v1";
  let cart = [];
  try{ cart = JSON.parse(localStorage.getItem(KEY)) || []; }catch(e){ cart = []; }
  const save = ()=>{ try{ localStorage.setItem(KEY, JSON.stringify(cart)); }catch(e){} };
  const count = ()=> cart.reduce((s,l)=>s+l.qty,0);

  function getLinePrice(p, size) {
    if (!p || p.poa) return 0;
    let base = Number(p.price) || 0;
    if (p.product_id) base = base / 100;
    
    let offset = 0;
    if (size === "36") offset = 5000;
    else if (size === "38") offset = 10000;
    else if (size === "40") offset = 15000;
    else if (size === "42") offset = 20000;
    else if (size === "M") offset = 3000;
    else if (size === "L") offset = 6000;
    else if (size === "XS") offset = -3000;
    return base + offset;
  }

  const subtotal = ()=> cart.reduce((s,l)=>{ const p=byId(l.id); return s + (p ? getLinePrice(p, l.size)*l.qty : 0); },0);

  function add(id,size,qty,custom){
    qty = qty||1; custom = custom||"";
    const p = byId(id); if(!p) return;
    const ln = cart.find(l=>l.id===id && l.size===size && (l.custom||"")===custom);
    if(ln){ ln.qty += qty; } else { cart.push({id,size:size||(p.sizes[0]||"OS"),qty,custom}); }
    save(); renderCart(); updateCount(); openDrawer(); showToast("Added to cart");
  }
  function setQty(i,d){ if(!cart[i])return; cart[i].qty+=d; if(cart[i].qty<1)cart.splice(i,1); save(); renderCart(); updateCount(); }
  function removeLine(i){ cart.splice(i,1); save(); renderCart(); updateCount(); showToast("Removed from cart"); }

  function updateCount(){
    document.querySelectorAll(".cart-count").forEach(el=>{ el.textContent = count(); el.style.opacity = count()? "1":"0"; });
    document.querySelectorAll(".wishlist-count").forEach(el=>{ el.textContent = wishlist.length; el.style.opacity = wishlist.length? "1":"0"; });
  }

  /* ----------------------------- Wishlist ------------------------------ */
  const W_KEY = "sveta-wishlist-v1";
  let wishlist = [];
  try{ wishlist = JSON.parse(localStorage.getItem(W_KEY)) || []; }catch(e){ wishlist = []; }
  const saveWishlist = ()=>{ try{ localStorage.setItem(W_KEY, JSON.stringify(wishlist)); }catch(e){} };
  
  function showToast(msg) {
    const container = document.getElementById("sv-toast-container");
    if (!container) return;
    const toast = document.createElement("div");
    toast.textContent = msg;
    toast.style.cssText = "background:var(--on-paper); color:var(--paper); padding:12px 24px; font-family:var(--sans); font-size:13px; font-weight:500; border-radius:4px; opacity:0; transform:translateY(-10px); transition:all 0.3s; pointer-events:auto; box-shadow:0 4px 12px rgba(0,0,0,0.15); text-transform:uppercase; letter-spacing:0.05em;";
    container.appendChild(toast);
    setTimeout(() => { toast.style.opacity = "1"; toast.style.transform = "translateY(0)"; }, 10);
    setTimeout(() => { 
      toast.style.opacity = "0"; toast.style.transform = "translateY(-10px)"; 
      setTimeout(()=>toast.remove(), 300);
    }, 3000);
  }

  function toggleWishlist(id) {
    const idx = wishlist.indexOf(id);
    let added = false;
    if(idx > -1) { wishlist.splice(idx,1); showToast("Removed from wishlist"); }
    else { wishlist.push(id); added = true; showToast("Added to wishlist"); }
    saveWishlist();
    updateCount();
    return added;
  }
  function inWishlist(id) { return wishlist.includes(id); }

  /* ------------------------- Drawer + mobile menu ---------------------- */
  function ensureChrome(){
    if(document.getElementById("sv-scrim")) return;
    const scrim = document.createElement("div");
    scrim.className="scrim"; scrim.id="sv-scrim";
    scrim.addEventListener("click", ()=>{ closeDrawer(); closeMenu(); });
    document.body.appendChild(scrim);

    const drawer = document.createElement("aside");
    drawer.className="drawer"; drawer.id="sv-drawer";
    drawer.innerHTML = `
      <div class="drawer-head">
        <h3>Your Selection</h3>
        <button class="drawer-close" aria-label="Close">Close &times;</button>
      </div>
      <div class="drawer-body" id="sv-cart-body"></div>
      <div class="drawer-foot" id="sv-cart-foot"></div>`;
    document.body.appendChild(drawer);
    drawer.querySelector(".drawer-close").addEventListener("click", closeDrawer);
    renderCart();
  }

  function renderCart(){
    const body = document.getElementById("sv-cart-body");
    const foot = document.getElementById("sv-cart-foot");
    if(!body||!foot) return;
    
    const initialLen = cart.length;
    cart = cart.filter(l => byId(l.id));
    if (cart.length !== initialLen) {
      save();
      updateCount();
    }
    
    if(!cart.length){
      body.innerHTML = `<div class="cart-empty">
          <p class="serif">Your selection is empty</p>
          <p class="drawer-note" style="margin-bottom:30px">Pieces you add will rest here</p>
          <a href="/collections/all" class="btn" style="padding:16px; background:var(--on-paper); color:var(--paper);">Enter the collection <span class="arrow">&rarr;</span></a>
        </div>`;
      foot.innerHTML = "";
      return;
    }
    body.innerHTML = cart.map((l,i)=>{
      const p = byId(l.id)||{};
      const linePrice = getLinePrice(p, l.size);
      const customHTML = l.custom ? `<div class="cl-ticket"><strong>BESPOKE MEASUREMENTS</strong><br>${l.custom.replace(/\\n/g, '<br>')}</div>` : "";
      let imgHTML = `<span class="ph-mark">\u015A</span>`;
      if (p.img_url) {
        imgHTML = `<img src="${p.img_url}" alt="${p.name}" style="width:100%; height:100%; object-fit:cover;">`;
      } else if (window.SVETA_ASSETS && window.SVETA_ASSETS[p.img]) {
        imgHTML = `<img src="${window.SVETA_ASSETS[p.img]}" alt="${p.name}" style="width:100%; height:100%; object-fit:cover;">`;
      }
      return `<div class="cart-line">
        <div class="ph ph--${p.tone||'stone'}" style="overflow:hidden;">
          ${imgHTML}
        </div>
        <div style="display:flex; flex-direction:column;">
          <div class="cl-name">${p.name||''}</div>
          <div class="cl-meta">${p.cat||''} &mdash; Size ${l.size}</div>
          ${customHTML}
          <div class="cl-price">${p.poa? "On request" : fmt(linePrice*l.qty)}</div>
          <div style="display:flex; justify-content:space-between; align-items:flex-end; margin-top:auto;">
            <div class="qty">
              <button data-q="dec" data-i="${i}" aria-label="decrease">&ndash;</button>
              <span>${l.qty}</span>
              <button data-q="inc" data-i="${i}" aria-label="increase">+</button>
            </div>
            <button class="cl-remove" data-rm="${i}">Remove</button>
          </div>
        </div>
      </div>`;
    }).join("");
    body.querySelectorAll("[data-q]").forEach(b=> b.addEventListener("click",()=> setQty(+b.dataset.i, b.dataset.q==="inc"?1:-1)));
    body.querySelectorAll("[data-rm]").forEach(b=> b.addEventListener("click",()=> removeLine(+b.dataset.rm)));
    const hasPoa = cart.some(l=> (byId(l.id)||{}).poa);
    foot.innerHTML = `
      <div class="subtotal"><span class="s-l">Subtotal</span><span class="s-v">${fmt(subtotal())}</span></div>
      <p class="drawer-note">${hasPoa? "Made-to-order pieces quoted at appointment &middot; ":""}Duties &amp; shipping calculated at checkout</p>
      <button class="btn" onclick="window.SVETA.checkout()">PROCEED TO CHECKOUT</button>
      <a class="thread gold" href="/pages/contact" style="display:block;text-align:center;margin-top:20px;font-size:9px;letter-spacing:0.3em;text-transform:uppercase">Book a private fitting</a>`;
  }

  function openDrawer(){ ensureChrome(); document.getElementById("sv-drawer").classList.add("open"); document.getElementById("sv-scrim").classList.add("open"); document.body.style.overflow="hidden"; }
  function closeDrawer(){ const d=document.getElementById("sv-drawer"); if(d)d.classList.remove("open"); syncScrim(); }
  function openMenu(){ const m=document.getElementById("sv-mmenu"); if(m){ m.classList.add("open"); document.getElementById("sv-scrim").classList.add("open"); document.body.style.overflow="hidden"; } }
  function closeMenu(){ const m=document.getElementById("sv-mmenu"); if(m)m.classList.remove("open"); syncScrim(); }
  function syncScrim(){
    const dOpen=document.querySelector(".drawer.open"), mOpen=document.querySelector(".mmenu.open");
    if(!dOpen&&!mOpen){ const s=document.getElementById("sv-scrim"); if(s)s.classList.remove("open"); document.body.style.overflow=""; }
  }

  /* --------------------------- Header behaviour ------------------------ */
  function initHeader(){
    const header = document.querySelector(".header");
    if(header){
      const onScroll = ()=>{ header.classList.toggle("solid", window.scrollY>40); };
      onScroll(); window.addEventListener("scroll", onScroll, {passive:true});
    }
    document.querySelectorAll("[data-cart-open]").forEach(b=> b.addEventListener("click", openDrawer));
    document.querySelectorAll("[data-menu-open]").forEach(b=> b.addEventListener("click", openMenu));
    document.addEventListener("keydown", e=>{ if(e.key==="Escape"){ closeDrawer(); closeMenu(); } });
  }

  function buildMobileMenu(){
    if(document.getElementById("sv-mmenu")) return;
    ensureChrome();
    let links = [];
    const menuDataEl = document.getElementById("siteMenuData");
    if (menuDataEl) {
      try { links = JSON.parse(menuDataEl.textContent).map(l => [l.title, l.url]); } catch(e) { links = []; }
    }
    const m = document.createElement("aside");
    const logoSrc = (document.querySelector(".logo-ink") || {}).src || "";
    m.className="mmenu"; m.id="sv-mmenu";
    m.innerHTML = `
      <div class="mmenu-top">
        <img src="${logoSrc}" alt="SVETA ATELIER">
        <button class="drawer-close" id="sv-mclose" style="color:var(--on-paper); cursor:pointer; background:none; border:none; padding:0; text-transform:uppercase; font-size:11px; letter-spacing:0.15em;">Close ×</button>
      </div>
      <nav>${links.map(l=>`<a class="m-link" href="${l[1]}">${l[0]}</a>`).join("")}</nav>
      <div class="mmenu-foot"><a href="/pages/contact">Contact</a><a href="${(window.SVETA_SOCIAL || {}).instagram || 'https://instagram.com'}" target="_blank" rel="noopener">Instagram</a><a href="/blogs/journal">Journal</a></div>`;
    document.body.appendChild(m);
    m.querySelector("#sv-mclose").addEventListener("click", closeMenu);
  }

  /* ------------------------------ Reveal ------------------------------- */
  // Scroll-position based (IntersectionObserver is unreliable inside preview iframes)
  let revealQueued = false;
  function checkReveal(){
    revealQueued = false;
    const h = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll("[data-reveal]:not(.in)").forEach(el=>{
      const r = el.getBoundingClientRect();
      if(r.top < h*0.92 && r.bottom > -40) el.classList.add("in");
    });
  }
  function queueReveal(){ if(revealQueued) return; revealQueued = true; requestAnimationFrame(checkReveal); }
  function initReveal(){
    checkReveal();
    window.addEventListener("scroll", queueReveal, {passive:true});
    window.addEventListener("resize", queueReveal, {passive:true});
    // safety: reveal everything shortly after load no matter what
    setTimeout(checkReveal, 250);
    window.addEventListener("load", ()=> setTimeout(checkReveal, 60));
  }

  /* ----------------------------- Add-to-cart --------------------------- */
  function initAddButtons(){
    document.querySelectorAll("[data-add]").forEach(b=>{
      b.addEventListener("click", e=>{
        e.preventDefault();
        const id=b.dataset.add;
        const sizeSel = b.dataset.sizeFrom ? document.querySelector(b.dataset.sizeFrom) : null;
        let size = sizeSel ? sizeSel.dataset.value : (b.dataset.size||"");
        const p = byId(id);
        if(p && p.poa){ location.href="/pages/contact"; return; }
        if(sizeSel && !size){ // require size
          const hint = document.querySelector(b.dataset.hint); if(hint){ hint.classList.add("show"); }
          return;
        }
        add(id,size,1);
      });
    });
  }

  function checkoutShopify() {
    if (!cart.length) return;
    if (isShopify) {
      const btn = document.querySelector("#sv-cart-foot .btn");
      if (btn) btn.innerHTML = "PREPARING...";
      const items = cart.map(l => {
        const p = byId(l.id) || {};
        let variantId = p.id;
        if (l.size && p.variants) {
          const v = p.variants.find(vx => String(vx.title) === String(l.size));
          if (v) variantId = v.id;
        }
        return {
          id: variantId,
          quantity: l.qty,
          properties: l.custom ? { 'Bespoke Measurements': l.custom } : {}
        };
      });
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }))
        .then(res => {
          if (!res.ok) throw new Error("Shopify rejected some items in the cart");
          cart = [];
          save();
          updateCount();
          window.location.href = "/checkout";
        }).catch(err => {
          console.error(err);
          location.href = '/pages/contact#checkout';
        });
    } else {
      location.href = '/pages/contact#checkout';
    }
  }

  /* -------------------------------- Init ------------------------------- */
  function init(){
    ensureChrome(); buildMobileMenu(); initHeader(); initReveal(); initAddButtons(); updateCount();
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* expose */
  window.SVETA = { catalog, byId, fmt, priceOf, getLinePrice, add, removeLine, openDrawer, closeDrawer, cart:()=>cart, count, reveal:checkReveal, checkout:checkoutShopify, wishlist:()=>wishlist, toggleWishlist, inWishlist };
})();
